module.exports = __webpack_public_path__ + "img/think-img.d38d52da.png";